<template>
  <el-dialog title="企业范围配置"
             :visible.sync="visible"
             width="840px"
             append-to-body
             @closed="handleClosed">
    <div class="vendor-transfer-wrap">
      <el-transfer v-model="ruleForm.multipleSelection"
                   filterable
                   :filter-method="filterMethod"
                   filter-placeholder="请输入企业名称"
                   :titles="['未应用', '已应用']"
                   :data="ruleForm.list"
                   :props="defaultProps"></el-transfer>
    </div>
    <div slot="footer">
      <el-button type="primary"
                 @click="addItem">更新</el-button>
      <el-button @click="visible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Supervise from '@/service/supervise'
export default {
  name: 'vendor-scope-set-modal',
  components: {},
  props: {
    callback: Function
  },
  data () {
    return {
      defaultProps: { key: 'vendorId', label: 'vendorName' },
      loading: false,
      ruleForm: { list: [], multipleSelection: [] },
      visible: false,
      staffInfo: {}
    }
  },
  methods: {
    filterMethod (query, item) {
      return item.vendorName.indexOf(query) > -1
    },
    handleClosed () {
      this.ruleForm = {
        list: [],
        multipleSelection: []
      }
      this.staffInfo = {}
    },
    fetchList () {
      this.loading = true
      Supervise.getvendors({ pageNum: 1, pageSize: 1000 })
        .then(res => {
          this.loading = false
          const { result, message, records } = res.data
          if (result === 0) {
            this.ruleForm.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          this.$message.error(err.message)
        })
    },
    fetch (row) {
      this.visible = true
      this.staffInfo = row
      this.loading = true
      Supervise.getstaffvendors({ staffId: row.staffId, pageNum: 1, pageSize: 1000 })
        .then(res => {
          this.loading = false
          const { result, message, records } = res.data
          if ([0, 13].includes(result)) {
            this.ruleForm.multipleSelection = records.map(i => i.vendorId)
            this.fetchList()
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          this.$message.error(err.message)
        })
    },
    addItem () {
      const result = this.ruleForm.multipleSelection
      // if (result.length === 0) {
      //   this.$message.error('请选择商品')
      //   return
      // }
      this.loading = true
      Supervise.setstaffvendors({ staffId: this.staffInfo.staffId, vendorIds: result, oper: 'update' })
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if (result === 0) {
            this.$message.success('更新成功')
            this.visible = false
            this.callback && this.callback()
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          this.$message.error(err.message)
        })
    }
  }
}
</script>
<style lang="stylus">
.vendor-transfer-wrap {
  .el-transfer {
    height: 400px;

    .el-transfer-panel {
      width: 300px;
      height: 100%;

      .el-transfer-panel__filter {
        margin 6px 0 !important;
      }
      .el-transfer-panel__body {
        height: calc(100% - 40px);

        .el-transfer-panel__list {
          height: calc(100% - 62px);
        }
      }
    }
  }
}
</style>
